import React, {Component} from "react";
import {Column} from "primereact/column";
import QueryPanel from "../../../../components/query/QueryPanel";
import ResultTable from "../../../../components/query/ResultTable";
import CriteriaPanel from "../../../../components/query/CriteriaPanel";
import {NumberInput, SelectInput, TextInput} from "../../../../components";
import PrimeDateRangeInput from "../../../../components/date-input/PrimeDateRangeInput";
import DateUtil from "../../../../utils/DateUtil";
import ClaimStatus from "../v2/claims/ClaimStatus";
import dialog from "../../../../components/dialog/Dialog";
import ClaimRemittanceDetail from "./ClaimRemittanceDetail";
import AddRemittanceModal from "./AddRemittanceModal";
import RemotingService from "../../../../services/remoting-service/RemotingService";
import {Dropdown} from "primereact/dropdown";
import {DEFAULT_INSTALLATION} from "../../../../utils/EnumInstallation";
import EnumCountry from "../../../../enums/EnumCountry";
import {Button} from "react-bootstrap";

const initialQueryOptions = {
    id: "",
    fileName: "",
    status: null,
    senderId: null,
    startDate: DateUtil.startOfDay(),
    endDate: DateUtil.endOfDay()
};

const noTpaOption = {id: null, name: "Not Applicable"};

export default class ClaimRemittance extends Component {

    constructor(props) {
        super(props);
        this.state = {
            tpas: [],
            selectedTpa: null,
            insuranceCompanies: [],
            selectedInsuranceCompany: null,
            dateRange: [initialQueryOptions.startDate, initialQueryOptions.endDate],
            queryOptions: {
                ...initialQueryOptions
            }
        }
    }

    handleDateRangeChange = (dateRange) => {
        this.setState((state) => {
            let newState = {...state, dateRange};
            if (dateRange && dateRange[0] && dateRange[1]) {
                // Mutate queryOptions in place; replacing the object would auto-query
                // via QueryPanel.componentDidUpdate — search stays behind the Search button
                newState.queryOptions.startDate = DateUtil.startOfDay(dateRange[0]);
                newState.queryOptions.endDate = DateUtil.endOfDay(dateRange[1]);
            }
            return newState;
        });
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (!prevProps.selected && this.props.selected) {
            this.costSubmissionQueryPanel.query();
        }
    }

    componentDidMount() {
        RemotingService.getRemoteCall('api/insurance/tpa/list', null, result => {
            if (DEFAULT_INSTALLATION.country === EnumCountry.KUWAIT) { // MD-1050: no-TPA option is Kuwait only
                result.unshift(noTpaOption);
            }
            this.setState({tpas: result});
        });
    }

    handleTpaChanged(tpa) {
        if (tpa) {
            RemotingService.getRemoteCall('api/insurance/tpa/company', {tpaId: tpa.id}, result => {
                this.setState((state) => {
                    let newState = {...state};
                    newState.selectedTpa = tpa;
                    newState.selectedInsuranceCompany = null;
                    newState.insuranceCompanies = result;
                    newState.queryOptions.senderId = tpa.eclaimlinkId;
                    return newState;
                });
            });
        } else {
            this.setState((state) => {
                let newState = {...state};
                newState.selectedTpa = null;
                newState.selectedInsuranceCompany = null;
                newState.insuranceCompanies = null;
                newState.queryOptions.senderId = null;
                return newState;
            });
        }
    }

    handleInsuranceCompanyChanged(insuranceCompany) {
        if (insuranceCompany) {
            this.setState((state) => {
                let newState = {...state};
                newState.selectedInsuranceCompany = insuranceCompany;
                newState.queryOptions.senderId = insuranceCompany.eclaimlinkId;
                return newState;
            });
        } else {
            this.setState((state) => {
                let newState = {...state};
                newState.selectedInsuranceCompany = null;
                newState.queryOptions.senderId = this.state.selectedTpa?.eclaimlinkId;
                return newState;
            });
        }
    }

    openRemittanceDetail(claimRemittance) {
        dialog({
            title: "Remittance Detail",
            component: <ClaimRemittanceDetail claimRemittanceId={claimRemittance.id} onGoToClaim={this.props.onGoToClaim}/>
        });
    }

    // One row per claim; a claim the payer sent that medai does not have has no button
    goToClaimTemplate(claimRemittance) {
        const claim = claimRemittance.claims?.[0];
        if (!claim || !this.props.onGoToClaim) {
            return null;
        }
        return <Button variant="link" size="sm" className="p-0"
                       onClick={() => this.props.onGoToClaim(claim.claimId)}>Go to claim</Button>;
    }

    openAddRemittance = () => {
        dialog({
            title: "Add Remittance",
            component: <AddRemittanceModal onSuccess={() => this.costSubmissionQueryPanel.query()}/>,
            style: {width: '600px'}
        });
    }

    clearQueryOptions = () => {
        this.setState({
            selectedTpa: null,
            insuranceCompanies: [],
            selectedInsuranceCompany: null,
            dateRange: [initialQueryOptions.startDate, initialQueryOptions.endDate],
            queryOptions: {...initialQueryOptions}
        });
    }

    idTemplate(claimRemittance) {
        return <a href="#" onClick={() => this.openRemittanceDetail(claimRemittance)}>{claimRemittance.id}</a>
    }

    dateTimeTemplate(dateStr) {
        return DateUtil.formatClinicDateTime(dateStr);
    }

    statusTemplate(claimRemittance) {
        return ClaimStatus[claimRemittance.status]?.name;
    }

    render() {
        return (
            <div>
                <div className="mb-2 text-right">
                    <Button variant="primary" size="sm" onClick={this.openAddRemittance}>Add Remittance</Button>
                </div>
                <QueryPanel ref={el => this.costSubmissionQueryPanel = el}
                            url="api/insurance/coordinator/v2/claims/claim-remittance/list"
                            queryOptions={this.state.queryOptions}
                            onClear={this.clearQueryOptions}>
                    <CriteriaPanel>
                        <div className="container text-left w-100 ml-0" style={{maxWidth: "inherit"}}>
                            <div className="row">
                                <div className="col-1">Date</div>
                                <div className="col-3">
                                    <PrimeDateRangeInput value={this.state.dateRange}
                                                         onChange={this.handleDateRangeChange}/>
                                </div>
                                <div className="col-1">Insurance Company</div>
                                <div className="col-3">
                                    <Dropdown className="w-100" showClear
                                              optionLabel="name"
                                              options={this.state.tpas}
                                              value={this.state.selectedTpa}
                                              onChange={e => this.handleTpaChanged(e.value)}/>
                                </div>
                                <div className="col-1">TPA</div>
                                <div className="col-3">
                                    <Dropdown className="w-100" showClear
                                              optionLabel="name"
                                              options={this.state.insuranceCompanies}
                                              value={this.state.selectedInsuranceCompany}
                                              onChange={e => this.handleInsuranceCompanyChanged(e.value)}/>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-1">Remittance ID</div>
                                <div className="col-3">
                                    <NumberInput className="w-100"
                                                 value={this.state.queryOptions.id}
                                                 onChange={value =>
                                                     this.setState((state) => {
                                                         let newState = {...state};
                                                         newState.queryOptions.id = value;
                                                         return newState;
                                                     })
                                                 }/>
                                </div>
                                <div className="col-1">File Name</div>
                                <div className="col-3">
                                    <TextInput className="w-100"
                                               value={this.state.queryOptions.fileName}
                                               onChange={value =>
                                                   this.setState((state) => {
                                                       let newState = {...state};
                                                       newState.queryOptions.fileName = value;
                                                       return newState;
                                                   })
                                               }/>
                                </div>
                                <div className="col-1">Status</div>
                                <div className="col-3">
                                    <SelectInput className="w-100" options={ClaimStatus.remittanceStatus}
                                                 displayProperty="name" valueProperty="key" searchEnabled={false}
                                                 value={this.state.queryOptions.status}
                                                 onChange={value =>
                                                     this.setState((state) => {
                                                         let newState = {...state};
                                                         newState.queryOptions.status = value;
                                                         return newState;
                                                     })
                                                 }/>
                                </div>
                            </div>
                        </div>
                    </CriteriaPanel>
                    <ResultTable scrollable responsive>
                        <Column field="id" header="Rem No" body={claimRemittance => this.idTemplate(claimRemittance)}/>
                        <Column header="Claim ID" body={claimRemittance => claimRemittance.claims?.[0]?.claimId}/>
                        <Column field="senderId" header="Sender ID"/>
                        <Column field="fileName" header="File Name"/>
                        <Column field="claimAmount" header="Claim Amount"/>
                        <Column field="paidAmount" header="Paid Amount"/>
                        <Column field="rejectedAmount" header="Rejected Amount"/>
                        <Column field="transactionDate" header="Transaction Date" body={claimRemittance => this.dateTimeTemplate(claimRemittance.transactionDate)}/>
                        <Column field="fileUploadDate" header="File Upload Date" body={claimRemittance => this.dateTimeTemplate(claimRemittance.fileUploadDate)}/>
                        <Column field="denialCode" header="Denial Code"/>
                        <Column field="status" header="Status" body={claimRemittance => this.statusTemplate(claimRemittance)}/>
                        <Column body={claimRemittance => this.goToClaimTemplate(claimRemittance)}/>
                    </ResultTable>
                </QueryPanel>
            </div>
        )
    }

}
